import styled from 'styled-components';
import { ColorDLS, ColorX11 } from '../../styling/color';
import {
  Card,
  DialogTitle,
  Link,
  Paper,
  TableCell,
  TableRow,
  Tabs,
  Typography,
} from '@dls/react-core';
import { em } from '@dls/react-theme';

export const PageWrapper = styled.div`
  margin: 1.5em;
  padding-bottom: 1.5em;
`;

export const StyledCollapsibleTableRow = styled(TableRow)`
  '& > *': {
    border-bottom: unset;
  }
`;

export const StyledTableNoBorder = styled(TableCell)`
  border: none !important;
`;

export const StyledBlueHeading = styled(Typography)`
  &&&& {
    color: ${ColorDLS.Blue45};
    margin-bottom: 0;
    font-weight: 400;
  }
`;

export const StyledCard = styled(Card)`
  display: flex;
`;

export const StyledPaperShadow = styled(Paper)`
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1), 0 2px 4px 0 rgba(0, 0, 0, 0.1);
`;

export const StyledPageTabBar = styled(Tabs)`
  box-shadow: none !important;
  border-bottom: 1px solid rgb(0 0 0 / 20%);
`;

export const StyledTabs = styled(Tabs)`
  margin-top: 1em;
  margin-left: 24px;
  box-shadow: none;
`;

export const StyledButtonContainerRight = styled.span`
  padding-right: ${em(16)};
`;

export const StyledHeaderContainer = styled.div`
  flex: 1;
  display: flex;
  background-color: ${ColorX11.White};
  border-radius: 2px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1), 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  height: 75px;
  margin-bottom: 16px;
  align-items: center;
  padding: 0 24px;
  justify-content: space-between;
`;

export const StyledContainer = styled.div`
  flex: 1;
  display: flex;
  background-color: ${ColorX11.White};
  border-radius: 2px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1), 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 16px;
  padding: 32px 24px;
  flex-direction: column;
`;

export const StyledTabWrapper = styled.div`
  background-color: ${ColorX11.White};
`;

export const StyledTabPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5em;
`;

export const StyledFormContainer = styled.form`
  margin-top: 24px;
`;

export const HorizontalListContainer = styled.div`
  display: flex;
  padding: 0 24px 32px 24px;

  div {
    flex: 1;
  }

  .itemlist {
    p {
      margin-top: 16px;
    }
  }
`;

export const FakeLink = styled(Link)`
  cursor: Pointer;

  :visited {
    color: ${ColorDLS.Blue45};
  }
`;

export const StyledDialogTitleForIcon = styled(DialogTitle)`
  display: inline-flex;
`;

export const StyledDialogIconContainer = styled.div`
  margin-top: 8px;
`;

export const StyledDialogHeading = styled(Typography)`
  margin-left: 8px;
`;
